import { jsx as _jsx } from "react/jsx-runtime";
import { CurrencySelectContainer, CustomSelect } from './styles';
export const CurrencySelect = (props) => {
    return (_jsx(CurrencySelectContainer, { optionsLength: props.options?.length, children: _jsx(CustomSelect, { ...props }) }));
};
export default CurrencySelect;
//# sourceMappingURL=CurrencySelect.js.map